import { RadioChip } from '@repo/ui/RadioChip';
import { Flex } from '@repo/ui/Flex';
import { useFormContext } from 'react-hook-form';
import type { ProductVariant } from '../../graphql/query/getResolutionOptions';
import { getAvailableAttrValues } from './helpers';
import s from './ExchangeDetails.module.css';
import type { AttributeFormSchemaType } from './ExchangeLayout';

export type ExchangeAttributeChipGroupProps = {
  name: string;
  itemId: string;
  variants: ProductVariant[];
  options: string[];
};

export const ExchangeAttributeChipGroup = (
  props: ExchangeAttributeChipGroupProps,
) => {
  const { name, variants, options } = props;
  const { register, watch } = useFormContext<AttributeFormSchemaType>();
  const selectedAttrs = watch('attributes');
  const selectedAttrValue = selectedAttrs[name];
  const availableValues = getAvailableAttrValues({
    variants,
    name,
    selectedAttrs,
  });

  return (
    <Flex gap="g-16" direction="column">
      <p className={s.attributeDescription}>
        <strong>{name}</strong>
        {selectedAttrValue && <span>&nbsp;-&nbsp;{selectedAttrValue}</span>}
      </p>
      <Flex gap="g-8" wrap="wrap">
        {options.map((value) => (
          <RadioChip
            id={value}
            key={value}
            value={value}
            disabled={!availableValues.includes(value)}
            {...register(`attributes.${name}`)}
          >
            {value}
          </RadioChip>
        ))}
      </Flex>
    </Flex>
  );
};
